import { Box, Spinner, VStack } from "@chakra-ui/react"
import Alert from "@pathwright/ui/src/components/alert/Alert"
import ToggleInput from "@pathwright/ui/src/components/form/form-toggle/ToggleInput"
import { Formik } from "formik"
import {
  FeatureActionType,
  FeatureKeyType,
  FeaturePermissionType,
  useContextualFeaturePermissionQuery,
  useCreateContextualFeaturePermissionMutation,
  useUpdateContextualFeaturePermissionMutation
} from "../../api/generated"

const FeaturePermissionsHomeScreenForm = () => {
  const baseVariables = {
    context: null,
    featureKey: FeatureKeyType.HomeScreenUnified,
    featureAction: FeatureActionType.HomeScreenView
  }

  const query = useContextualFeaturePermissionQuery({
    variables: baseVariables
  })

  const [createMutation] = useCreateContextualFeaturePermissionMutation()
  const [updateMutation] = useUpdateContextualFeaturePermissionMutation()
  const mutation = query.data?.contextualFeaturePermission
    ? updateMutation
    : createMutation

  if (query.loading) {
    return (
      <VStack py={4} justifyContent="center">
        <Spinner />
      </VStack>
    )
  }

  if (query.error) {
    return <Alert error={query.error} />
  }

  const initialValues = {
    [FeatureActionType.HomeScreenView]:
      query.data?.contextualFeaturePermission?.permission_in_context ===
      FeaturePermissionType.Everyone
  }

  return (
    <Formik
      initialValues={initialValues}
      // enableReinitialize allows the form to reset to new state after submission
      enableReinitialize
      onSubmit={(values) =>
        mutation({
          variables: {
            ...baseVariables,
            permissionInContext: values[FeatureActionType.HomeScreenView]
              ? FeaturePermissionType.Everyone
              : FeaturePermissionType.Disabled
          }
        })
      }
    >
      {(form) => {
        return (
          <Box as="form" minW="full" py={4}>
            <ToggleInput
              labelWidth={300}
              label="Enable the new Unified Home Screen"
              value={form.values[FeatureActionType.HomeScreenView]}
              onChange={async (value: boolean) => {
                await form.setFieldValue(
                  FeatureActionType.HomeScreenView,
                  value,
                  false
                )
                form.submitForm()
              }}
              alignRight
            />
          </Box>
        )
      }}
    </Formik>
  )
}

export default FeaturePermissionsHomeScreenForm
